import {CTA, Container, Text, styled} from '@volkswagen-onehub/components-core'
import {SizeEnum} from '@volkswagen-onehub/tokens'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import {RootState} from '../rootReducer'
import {closeDisclaimerLayer} from './launchers/LegalNotesLayerHandle'

const LegalNotesDisclaimerTextContainer = styled.div`
    p {
        margin: 0;
    }
`
export const LegalNotesLayer = () => {
    const {t} = useTranslation('fa-flotte')

    const legalNotes = useSelector(
        (state: RootState) => state.layersHandle.legalNotesText
    )

    return (
        <Container
            gutter={SizeEnum.static300}
            padding={SizeEnum.static350}
            wrap="always"
        >
            <Text>
                <LegalNotesDisclaimerTextContainer
                    dangerouslySetInnerHTML={{
                        __html: legalNotes,
                    }}
                />
            </Text>
            <CTA
                onClick={closeDisclaimerLayer}
                tag="button"
                emphasis="secondary"
            >
                {t('cta.close')}
            </CTA>
        </Container>
    )
}
